import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Assuming you have this function for logging

// Assuming ChampStruct has a method to convert to JSON
class ChampStruct {
  constructor(type, content, bb, pp, ww, hh, label, page) {
    this.type = type;
    this.content = content;
    this.bb = bb;
    this.pp = pp;
    this.ww = ww;
    this.hh = hh;
    this.label = label;
    this.page = page;
  }

  toJson() {
    return {
      type: this.type,
      content: this.content,
      bb: this.bb,
      pp: this.pp,
      ww: this.ww,
      hh: this.hh,
      label: this.label,
      page: this.page,
    };
  }
}

const signRE2020 = async (
  champs,
  token,
  attestationId,
  prefix,
  width,
  height,
  fileName
) => {
  const url =
    prefix +
    `rtb/re_2020/sign`;

  // Modify Champs types and content as per the original logic
  champs.forEach((champ) => {
    if (champ.type === "Initiales") {
      champ.type = "Signature";
    } 
  });

  champs = champs.map((champ) =>
    champ instanceof ChampStruct
      ? champ
      : new ChampStruct(
          champ.type,
          champ.content,
          champ.bb,
          champ.pp,
          champ.ww,
          champ.hh,
          champ.label,
          champ.page
        )
  );

  const fields = champs.map((champ) => champ.toJson());

  // Request body
  const body = {
    attestation_id: attestationId,
    fields: fields,
    target_height: height,
    target_width: width,
    filename: fileName,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Send POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(userRef);
    const org_id = userSnapshot.get("org_id");

    const responseText = await response.text();
    let end = new Date();
    let elapsed = end - start;
    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef, // Log userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseText,
      "POST",
      elapsed
    );

    // Check response
    if (response.ok) {
      return true
    } else {
      console.error(`Failed to send request: ${response.status}`);
      return false;
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    throw new Error("Request failed");
  }
};

export default signRE2020;
